import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  companyInfo: [],
};

export const company = createSlice({
  name: "company",
  initialState,
  reducers: {
    // 회사 멤버
    createCompanyInfo: (state, action) => {
      state.companyInfo = action.payload;
    },
    addCompanyInfo: (state, action) => {
      state.companyInfo = [...state.data, action.payload];
    },
    updateCompanyInfo: (state, action) => {
      const updated = action.payload;
      state.companyInfo = state.companyInfo.map((item) =>
        item.cmpnyNo === updated.cmpnyNo && item.mberNo === updated.mberNo ? updated : item,
      );
    },
    // 회사
    createCompany: (state, action) => {
      state.data = action.payload;
    },
    updateCompany: (state, action) => {
      const updatedCompany = action.payload;
      state.data = state.data.map((item) =>
        item.cmpnyNo === updatedCompany.cmpnyNo ? updatedCompany : item,
      );
    },
    addCompany: (state, action) => {
      state.data = [...state.data, action.payload];
    },
    deleteCompany: (state, action) => {
      state.data = state.data.filter((item) => item.cmpnyNo !== action.payload);
    },
    resetCompany: (state) => {
      state.data = [];
      state.companyInfo = [];
    },
  },
});

export const {
  createCompany,
  updateCompany,
  addCompany,
  deleteCompany,
  resetCompany,
  createCompanyInfo,
  addCompanyInfo,
  updateCompanyInfo,
} = company.actions;
export default company;
